module.exports = __webpack_public_path__ + "img/Villa_Borna_51.db98f64f.jpg";